'use strict';
import { BaseInlineFilter } from './base-inline-filter';
import template from './string-filter.html';

export class StringFilter extends BaseInlineFilter {
	constructor(options) {
		super(options);

		this.type = 'string';
		this.panelTemplate = template;
		this.operators = this.filterOperatorsFactory.getOperatorsByType('String');
		this.maxWordsPerCondition = this.configService.get('maxWordsPerCondition');
		this.maxWordsValidationMessage = this.i18n.getFormatted('solutionBuilderAgent.components.mx-search-query-condition.tooManyWords', this.maxWordsPerCondition);
	}

	getNewValue() {
		switch (this.operatorOnForm) {
			case this.allOperators.IsSet.value:
			case this.allOperators.IsNotSet.value:
				return [];
			default:
				return [this.valueOnForm];
		}
	}

	setDefault() {
		this.operator = this.operatorOnForm = this.allOperators.Contains.value;
		this.valueOnForm = '';
	}

	updateTitle() {
		switch (this.operator) {
			case this.allOperators.IsSet.value:
			case this.allOperators.IsNotSet.value:
				this.title = this.operatorTitle;
				break;
			default:
				this.title = this.operatorLabel + ' ' + this.value[0];
		}
	}

	isFormValid() {
		const newValue = this.getNewValue();
		const searchText = newValue && newValue[0];

		switch (this.operatorOnForm) {
			case this.allOperators.IsSet.value:
			case this.allOperators.IsNotSet.value:
				return true;
			case this.allOperators.ContainsAllWords.value:
			case this.allOperators.ContainsAnyWord.value:
			case this.allOperators.DoesNotContainAnyWord.value:
			case this.allOperators.DoesNotContainAllWords.value: {
				const correct = searchText && searchText.split(/[,|.|;| ]/).length <= this.maxWordsPerCondition;
				this.validationMessage = searchText && !correct ? this.maxWordsValidationMessage : null;
				return correct;
			}
			default:
				return Boolean(searchText);
		}
	}

	hasValue() {
		switch (this.operator) {
			case this.allOperators.IsSet.value:
			case this.allOperators.IsNotSet.value:
				return true;
			default:
				return Boolean(this.value && this.value[0]);
		}
	}

	syncFormFromInline(inlineValue) {
		this.valueOnForm = inlineValue;
	}
}
